function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validatePhone(phone) {
    // var patternPhone = /^(01[016789]-[^0][0-9]{3,4}-[0-9]{4})$/;
    var patternPhone = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/;
    return patternPhone.test(phone);
}

function validateComTel(tel) {
    var patternTel = /^\d{2,3}-\d{3,4}-\d{4}$/;
    return patternTel.test(tel);
}

function checkPassword(password) {
    var patternPassword = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~`!@#$%^&*()-+=]{8,16}$/;
    return patternPassword.test(password);
}

function validateURL(url) {
    let patternURl = /(http(s)?:\/\/)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}/gi;
    return patternURl.test(url);
}


export { validateEmail, validatePhone, checkPassword, validateComTel, validateURL };